import { render } from "./JamiiCover.vue?vue&type=template&id=3ee021b6&scoped=true"
import script from "./JamiiCover.vue?vue&type=script&lang=js"
export * from "./JamiiCover.vue?vue&type=script&lang=js"

import "./JamiiCover.vue?vue&type=style&index=0&id=3ee021b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee021b6"]])

export default __exports__